import { useQuery } from "@tanstack/react-query";
import { getTotalWorkforce } from "../actions/getTotalWorkforce.action";

export const useGetTotalWorkforce = () => {
    return useQuery({
        queryKey: ["total-workforce"],
        queryFn: getTotalWorkforce,
    });
}